/** Коэффициент отношения ширины к высоте слайдера. */
export const COEFF = 1.63;
